module.exports = __webpack_public_path__ + "img/cloud-practitioner-logo.25ede0a6.png";